/**
 * Procedure Categories and Procedures for M.Ch. in Gynaecological Oncology students
 * Extracted with strict evidence from official NMC PDF (Page 5, 8-9: "Psychomotor domain - independently and competently performed")
 */
export const GYNAECOLOGICAL_ONCOLOGY_PROCEDURES = {
  "Radical Oncological & Pelvic Resection Procedures": [
    "Radical, Total Abdominal & Vaginal Hysterectomy",
    "Complete Pelvic & Para-Aortic Lymph Node Dissection (Lymphadenectomy)",
    "Radical Vulvectomy & Inguinal / Femoral Lymphadenectomy",
    "Primary, Interval & Secondary Debulking Surgery for Ovarian Malignancies",
    "Fertility-Sparing & Conservative Surgery for Early-Stage Gynaecological Cancers",
    "Laparoscopic Surgery for Endometrial & Cervical Carcinoma",
    "Pelvic Exenteration Procedures",
  ],
  "Diagnostic Endoscopic, Biopsy & Reconstructive Surgical Procedures": [
    "Diagnostic & Operative Cystoscopy, Proctosigmoidoscopy & Hysteroscopy",
    "Directed Cervical Biopsy, Cone Biopsy & LEEP Biopsy of Cervix",
    "Endocervical & Endometrial Biopsy and Curettage",
    "Vulval, Pelvic & Abdominal Lymph Node Biopsies",
    "Transvaginal & Transabdominal Fine Needle Aspiration Biopsy (FNAB) of Pelvic Masses",
    "Intestinal Resection, Re-anastomosis, Colostomy & Ileostomy",
    "Ureteral Re-anastomosis, Ureteroneocystotomy & Partial Cystectomy",
  ],
};

export const GYNAECOLOGICAL_ONCOLOGY_CATEGORIES = Object.keys(GYNAECOLOGICAL_ONCOLOGY_PROCEDURES);

export const isMChInGynaecologicalOncologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("gynaecological oncology") ||
    d.includes("gynecologic oncology") ||
    d.includes("gynaec oncology")
  );
};
